import React from 'react';
import { Footer } from '@comparaonline/navigation/compara-ui-navigation';

export const FooterApp = () => {
  const footerConfig = window.navigationConfig.footer;

  return (
    <>
      <Footer {...footerConfig} />
    </>
  );
};
